import { register } from '@shopify/theme-sections'
import { formatMoney } from '@shopify/theme-currency';
import {getUrlWithVariant} from '@shopify/theme-product-form';
import UniqueId from 'vue-unique-id'
import ProductForm from '../components/product-form';
import ProductDetails from '../components/pdp-details';

Vue.use(UniqueId)

register('pdp-main', {
  onLoad() {
    const data = JSON.parse(this.container.querySelector('[data-product]').innerHTML)
    const product = data.product
    const variants = data.variants
    const initialVariantId = data.initialVariantId
    const initialVariant = variants.find( v => v.id == initialVariantId)
    product.variants = variants

    this.swiper = new Swiper(this.container.querySelector('.swiper-container'), {
      loop: (this.container.querySelectorAll('.swiper-slide').length > 1) ? true : false,
      roundLengths: true,
      grabCursor: true,
      spaceBetween: 0,
      slidesPerView: 1,
      a11y: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },
      navigation: {
        nextEl: '.pdp-button-next',
        prevEl: '.pdp-button-prev',
      },
      keyboard: {
        enabled: true,
        onlyInViewport: false,
      },
    });

    this.vue = new Vue ({
      el: this.container.querySelector('.product-details-wrapper'),
      delimiters: ['#{', '}'],
      components: {
        ProductForm,
        ProductDetails
      },
      data: {
        product: product,
        selectedVariant: {},
        initialVariant: initialVariant
      },
      methods: {
        variantChanged(variant) {
          this.selectedVariant = variant
          const url = getUrlWithVariant(window.location.href, variant.id);
          window.history.replaceState({path: url}, '', url);
        },
        formatPrice(price, format) {
          return formatMoney(price, (format ? format : theme.moneyFormat))
        }
      }
    })
  },

  onUnload() {
    this.swiper.destroy()
    this.vue.destroy()
  }

});
